import { gql } from '@edreamsodigeo/frontend-api-client';
import { api as sectionFragment } from './section';

export const api = gql`
  fragment Segment on Segment {
    id
    duration
    carrier {
      id
      name
    }
    sections {
      ...Section
    }
    baggageCondition
    transportTypes
  }

  ${sectionFragment}
`;
